export default {
  // Settings nav groups
  groupTeam: 'Team',
  groupBlocks: 'Blocks',
  groupPersonal: 'Personal',
  groupWorkspace: 'Workspace',
  groupDeveloper: 'Developer',
  groupAdmin: 'Admin',

  // Settings nav tabs
  tabTeamGeneral: 'General',
  tabTeamMembers: 'Members',
  tabEmail: 'Email',
  tabCalendar: 'Calendar',
  tabAgents: 'Agents',
  tabRoutines: 'Routines',
  tabCrm: 'CRM',
  tabAccount: 'Account',
  tabAppearance: 'Appearance',
  tabNotifications: 'Notifications',
  tabShortcuts: 'Keyboard shortcuts',
  tabUsage: 'Usage',
  tabBilling: 'Billing',
  tabDesktopApp: 'Desktop App',
  tabMobileApp: 'Mobile App',
  tabTags: 'Tags',
  tabIntegrations: 'Integrations',
  tabRuntimes: 'Runtimes',
  tabMcpServer: 'MCP server',
  tabApiKeys: 'API Keys',
  tabBots: 'Bots',
  tabDebug: 'Debug',

  // Sidebar and sheet chrome
  settings: 'Settings',
  settingsNavigation: 'Settings navigation',
  searchSettings: 'Search settings',
  noSettingsFound: 'No settings found',
  searchResults: 'Settings search results',
  searchResultCount: {
    one: '{{count}} setting found',
    other: '{{count}} settings found',
  },
  searchNoResults:
    'No settings found. Try “signature”, “theme”, or “calendar”.',
  backToSettings: 'Back to settings',
  closeSettings: 'Close settings',
  goToTab: 'Go to settings tab {{number}}',
  editProfile: 'Edit profile',
  logOut: 'Log out',
  yourAccount: 'Your account',
  pageLoadFailed: 'This settings page couldn’t load.',
  tryAgain: 'Try again',
  loadingSettings: 'Loading settings…',
  sectionUnavailable: 'This settings section is unavailable.',
  createTeam: 'Create a team',
  inviteTeam: 'Invite your team',
};
